<template>
    <div id="productlabelspage">
        <actions-menu>
            <actions-menu-item
                :v4="true"
                :action="back"
                icon="arrow-left"
                :label="trans('pages.product_labels.to_product')"
            />
        </actions-menu>
        <template v-if="labels">
            <ui5-list v-if="labels.length">
                <ui5-li
                    v-for="label in labels"
                    :key="label.ID"
                    @click="goToPage(label)"
                >
                    {{ label.name }}
                </ui5-li>
            </ui5-list>
            <div
                class="error"
                v-else
            >
                {{ trans('pages.product_labels.no_labels') }}
            </div>
        </template>
        <spinner-text v-else>
            {{ trans('pages.product_labels.loading') }}
        </spinner-text>
    </div>
</template>
<style scoped>
ui5-list {
    clear: both;
}
</style>
<script>
import ActionsMenu from '../components/ActionsMenu';
import ActionsMenuItem from '../components/ActionsMenuItem';
import SpinnerText from '../components/loader/SpinnerText';
import labelApi from '../api/label';
import IdParamMixin from '../mixins/id-param';
import NavigationFunctionsMixin from '../mixins/navigation-functions';
import { loadPage } from '../helpers/NavigationHelper';
import localization from '../mixins/localization';

export default {
    mixins: [IdParamMixin(), NavigationFunctionsMixin, localization],
    components: {
        SpinnerText,
        ActionsMenu,
        ActionsMenuItem,
    },
    data() {
        return {
            productId: null,
            labels: null,
        };
    },
    methods: {
        back() {
            this.goToProductPage(this.productId);
        },
        goToPage(label) {
            loadPage(label.htmlPage + '/' + label.ID);
        },
        load() {
            this.productId = this.$route.params.id;
            this.$store.commit(
                'general/setPageTitle',
                this.trans('pages.product_labels.labels_for', {
                    productId: this.productId,
                }),
                { root: true }
            );
            labelApi.listProductTypeLabels(this.productId).then((response) => {
                this.labels = response.data.data;
                if (this.labels && this.labels.length) {
                    this.$store.commit(
                        'general/setPageTitle',
                        this.trans('pages.product_labels.labels_for', {
                            productId: this.labels[0].productNr,
                        }),
                        { root: true }
                    );
                }
            });
        },
    },
};
</script>
